import React from 'react';
import { LogOutIcon, BellIcon, ChevronDownIcon } from 'lucide-react';
export const Navbar = () => {
  return <nav className="fixed top-0 left-0 right-0 h-16 bg-white border-b border-gray-200 z-50" data-id="element-510">
      <div className="h-full flex items-center justify-between px-4" data-id="element-511">
        <div className="flex items-center" data-id="element-512">
          <div className="h-8 w-24 bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg flex items-center justify-center" data-id="element-513">
            <span className="text-white font-bold text-lg tracking-wide" data-id="element-514">
              SimFin
            </span>
          </div>
        </div>
        <div className="flex items-center gap-4" data-id="element-515">
          <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-full relative" data-id="element-516">
            <BellIcon className="h-5 w-5" data-id="element-517" />
            <span className="absolute top-1 right-1 h-2 w-2 bg-red-500 rounded-full" data-id="element-518"></span>
          </button>
          <div className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-519">
            <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="User avatar" className="h-8 w-8 rounded-full" data-id="element-520" />
            <div className="flex flex-col" data-id="element-521">
              <span className="text-sm font-medium text-gray-900" data-id="element-522">
                John Doe
              </span>
              <span className="text-xs text-gray-500" data-id="element-523">Administrador</span>
            </div>
            <ChevronDownIcon className="h-4 w-4 text-gray-500" data-id="element-524" />
          </div>
          <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-full" data-id="element-525">
            <LogOutIcon className="h-5 w-5" data-id="element-526" />
          </button>
        </div>
      </div>
    </nav>;
};